import PropTypes from 'prop-types';


import {contentConstants} from '../Content';
import {listConstants} from '../List';
import {PAGE_DEFAULT_PAGE} from '../../../services/ApiService/apiConstants';


// ------ actions
export const ACTION_SEARCH_REQUEST = 'SEARCH_REQUEST';



// ------ departments
export const DEPARTMENT_ALL = 'all';


// ------ item type
export const ITEM_TYPE_CONTENT = 'content';

export const ITEM_TYPES = [
    ITEM_TYPE_CONTENT
];


// ------ page sizes
export const PAGE_SIZE_12 = 12;
export const PAGE_SIZE_24 = 24;
export const PAGE_SIZE_48 = 48;
export const PAGE_SIZE_96 = 96;

export const PAGE_SIZE_DEFAULT = PAGE_SIZE_12;

export const PAGE_SIZES = [
    PAGE_SIZE_12,
    PAGE_SIZE_24,
    PAGE_SIZE_48,
    PAGE_SIZE_96
];


// ------ sort by
export const SORT_BY_SCORE = 'score';

export const SORT_BY_DEFAULT = SORT_BY_SCORE;

export const SORT_BYS = [
    SORT_BY_SCORE
];



export const SEARCH_REQUEST_DEFAULT = {
    department: DEPARTMENT_ALL,
    isDefault: true,
    page: PAGE_DEFAULT_PAGE,
    pageSize: PAGE_SIZE_DEFAULT,
    sortBy: SORT_BY_DEFAULT,
    text: ''
};



// ------ shapes
export const SHAPE_SEARCH_REQUEST = {
    department: PropTypes.string.isRequired,
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    sortBy: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
};


export const SHAPE_SEARCH_REQUEST_DEFAULT = {
    department: DEPARTMENT_ALL,
    page: 0,
    pageSize: PAGE_SIZE_DEFAULT,
    sortBy: SORT_BY_DEFAULT,
    text: ''
};


export const SHAPE_ITEM = {
    data: PropTypes.oneOfType(
        [
            PropTypes.shape(contentConstants.SHAPE_CONTENT_TILE)
        ]
    ),
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(ITEM_TYPES)
};


export const SHAPE_SEARCH_RESULTS = {
    ...listConstants.SHAPE_LIST_ROOT,
    items: PropTypes.arrayOf(
        PropTypes.shape(SHAPE_ITEM)
    ).isRequired,
    isEmpty: PropTypes.bool.isRequired
};
